import { Link } from 'react-router-dom';

function ManualHomePage() {
  return (
    <div className="manual-page">
      <div className="content-header">
        <h1 className="content-title">
          <i className="bi bi-book me-3"></i>
          Manual do Usuário
        </h1>
        <p className="content-subtitle">
          Sistema de Movimentação - SEJUS-DF
        </p>
      </div>

      <div className="manual-intro-card">
        <h2>Sobre este Manual</h2>
        <p>
          Este manual foi criado para ajudá-lo a utilizar o Sistema de Movimentação de forma simples e eficiente.
          Aqui você encontrará orientações passo a passo sobre todas as funcionalidades do sistema.
        </p>
        <p>
          <strong>Não é necessário conhecimento técnico!</strong> Todas as explicações são feitas em linguagem clara e acessível.
        </p>
      </div>

      <div className="manual-grid">
        <Link to="/painel/manual/introducao" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-info-circle"></i>
          </div>
          <h3>Introdução ao Sistema</h3>
          <p>Conheça o sistema, seus objetivos e como ele funciona</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/primeiro-acesso" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-key"></i>
          </div>
          <h3>Primeiro Acesso</h3>
          <p>Como fazer login e navegar pela primeira vez</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/adolescentes" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-people"></i>
          </div>
          <h3>Cadastro de Adolescentes</h3>
          <p>Como cadastrar, buscar e visualizar informações</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/movimentacoes" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-arrow-left-right"></i>
          </div>
          <h3>Movimentações</h3>
          <p>Registre entradas, saídas e acompanhe o fluxo</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/atendimentos" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-clipboard-check"></i>
          </div>
          <h3>Atendimentos</h3>
          <p>Registre atendimentos de promotoria, defensoria, saúde e mais</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/dashboard" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-speedometer2"></i>
          </div>
          <h3>Painel de Controle</h3>
          <p>Visualize estatísticas e informações em tempo real</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/relatorios" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-pie-chart"></i>
          </div>
          <h3>Relatórios</h3>
          <p>Acompanhe gráficos e indicadores operacionais em tempo real</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/usuarios" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-person-badge"></i>
          </div>
          <h3>Gerenciar Usuários</h3>
          <p>Adicione e gerencie usuários do sistema</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/configuracoes" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-gear"></i>
          </div>
          <h3>Configurações</h3>
          <p>Configure tabelas de apoio, perfis e permissões</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/perguntas-frequentes" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-question-circle"></i>
          </div>
          <h3>Perguntas Frequentes</h3>
          <p>Respostas para dúvidas comuns</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/minha-conta" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-person-circle"></i>
          </div>
          <h3>Minha Conta</h3>
          <p>Consulte seus dados e gerencie sua senha com segurança</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/logs" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-activity"></i>
          </div>
          <h3>Logs do Sistema</h3>
          <p>Monitore auditoria, filtros e eventos em tempo real</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>

        <Link to="/painel/manual/glossario" className="manual-card">
          <div className="manual-card-icon">
            <i className="bi bi-bookmark"></i>
          </div>
          <h3>Glossário de Termos</h3>
          <p>Consulte o significado dos principais termos usados no sistema</p>
          <span className="manual-card-arrow">
            <i className="bi bi-arrow-right"></i>
          </span>
        </Link>
      </div>

      <div className="manual-help-section">
        <h3>
          <i className="bi bi-lightbulb me-2"></i>
          Dica Rápida
        </h3>
        <p>
          Use o menu lateral para navegar entre os tópicos do manual. Você pode voltar a esta página
          inicial a qualquer momento clicando em <strong>"Início"</strong> no menu.
        </p>
      </div>
    </div>
  );
}

export default ManualHomePage;
